import { Component, OnInit } from '@angular/core';
import { StockingServiceService } from '../stocking-service.service';
import systemInfoFile from '../system-configs.json';

let systemTypes = {}
//{
//   "BAGUETTE A": "baguetter",
//   "BAGUETTE F": "baguetter",
//   "BAGUETTE HB": "baguetter",
//   "BURGER A": "burger",
//   "SALAT B": "salater",
//   "COOKIE A": "bakevarer",
//   "SUB B": "subs",
//   "SUPPE": "suppe",
//   "YOGHURT B": "yoghurt",
//   "SALAT A": "salater",
//   "MIDDAG B": "varmretter",
//   "BAGUETTE B": "baguetter",
//   "BAGUETTE C": "baguetter",
//   "BAGUETTE D": "baguetter",
//   "WRAP A": "wrap",
//   "BURGER B": "burger",
//   "YOGHUR dT A": "yoghurt",
//   "BAGUETTE HA": "baguetter",
//   "MIDDAG A": "varmretter",
//   "BAGUETTE E": "baguetter",
//   "SUB A": "subs",
//   "MUFFINS B": "bakevarer",
//   "MUFFINS A": "bakevarer"
// }


@Component({
  selector: 'app-system-stocking-config',
  templateUrl: './system-stocking-config.component.html',
  styleUrl: './system-stocking-config.component.css'
})
export class SystemStockingConfigComponent implements OnInit {

  systems: any[] = []

  categories = Object.keys(systemTypes).map(key => systemTypes[key]).filter((value, index, self) => self.indexOf(value) === index).map(category => ({
    name: category,
    turbo: 1,
    minimum: 0,
  })).sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()));

  productTypes = Object.keys(systemTypes).sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));
  types = {}



  // weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
  constructor(private stockingService: StockingServiceService) {
    // let systemInfo = JSON.parse(JSON.stringify(systemInfoFile));
    // for (const key in systemInfo) {
    //   if (systemInfo.hasOwnProperty(key)) {
    //     this.types[key] = systemInfo[key];
    //     this.stockingService.getSystemBySystemId(key).subscribe(systemArr => {
    //       console.log(key, systemArr);
    //       if (systemArr.length > 0) {
    //         // Synchronize types array and categoryTurbo
    //         const sysObj = { ...this.types[key], id: systemArr[0].id };
    //         const importedTurbo = systemInfo[key].categoryTurbo || {};
    //         // Build types array from importedTurbo
    //         const typesArr = Object.keys(importedTurbo).map(typeName => ({
    //           name: typeName,
    //           turbo: importedTurbo[typeName],
    //           minimum: 0,
    //           category: systemTypes[typeName] || ''
    //         }));
    //         sysObj.types = typesArr;
    //         sysObj.categoryTurbo = importedTurbo;
    //         this.saveSystem(sysObj);
    //       }
    //     });
    //   }
    // }



  }



  ngOnInit(): void {
    this.stockingService.getProductTypes().subscribe(productTypes => {
     
          systemTypes = productTypes
       
      console.log(systemTypes);
    })
    this.stockingService.getSystems$().subscribe((systems) => {
      this.systems = systems.map(system => {
        // Ensure categoryMinimum is always an object to avoid template errors
        const savedCategoryMinimum = system?.systemConfig?.categoryMinimum ? { ...system.systemConfig.categoryMinimum } : {};

        return {
          turbo: 1,
          categories: Object.keys(systemTypes)
            .map(key => systemTypes[key])
            .filter((value, index, self) => self.indexOf(value) === index)
            .map(category => ({
              name: category,
              turbo: 1,
              minimum: 0,
            }))
            .sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())),
          ...system,
          ...system.systemConfig,
          categoryMinimum: savedCategoryMinimum,
          types: Object.keys(systemTypes || {})
            .map(key => {
              // Find type object where name === key
              const typeObj = system.systemConfig?.types?.find((t: any) => t.name === key);
              return {
                name: key,
                category: systemTypes[key],
                turbo: typeObj ? typeObj.turbo : 1,
                // Prefer explicit type.minimum, otherwise fall back to saved categoryMinimum for that type
                minimum: typeObj?.minimum ?? savedCategoryMinimum?.[key] ?? 0,
              };
            })
            .sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())),
          weekTurbo: [
            { turbo: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[0].turbo : 1, disabled: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[0].disabled : false, day: 'Monday', dayIndex: 1 },
            { turbo: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[1].turbo : 1, disabled: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[1].disabled : false, day: 'Tuesday', dayIndex: 2 },
            { turbo: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[2].turbo : 1, disabled: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[2].disabled : false, day: 'Wednesday', dayIndex: 3 },
            { turbo: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[3].turbo : 1, disabled: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[3].disabled : false, day: 'Thursday', dayIndex: 4 },
            { turbo: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[4].turbo : 1, disabled: system.systemConfig?.weekTurbo ? system.systemConfig?.weekTurbo[4].disabled : false, day: 'Friday', dayIndex: 5 }
          ],
        };

      })
    })
  }

  saveSystem(system: any) {
    this.stockingService.saveSystem(system).then(() => {
      console.log('System saved successfully');

    }).catch(error => {
      console.error('Error saving system:', error);
    });
  }
  toPercent(value: number): string {
    return (value * 100).toFixed(0) + '%';
  }

}
